import CultureCreate from "./CulturesCreate";
import { CulturesList } from "./CulturesList";
import CulturesShow from "./CulturesShow";
import { CultureEdit } from "./CulturesEdit";

export const cultures = {
  create: CultureCreate,
  list: CulturesList,
  show: CulturesShow,
  edit: CultureEdit,
};
